import Pusher from "pusher-js";

// Initialize Pusher
const pusher = new Pusher(window.env.REACT_APP_PUSHER_KEY, {
  cluster: window.env.REACT_APP_PUSHER_CLUSTER,
  encrypted: true,
 
});


export default pusher;
